import { i18n } from '../../../../language';
import User from './User';
import Ward from './Ward';
import RoleAdd from './Role/RoleAdd';
import RoleEdit from './Role/RoleEdit';

const AddWardPop = ({ closePop, open, confirmClick }) => {
  const props = {
    title: i18n.t('SETTING_ADD_WARD'),
    confirmText: i18n.t('SETTING_ADD'),
    open,
    closePop,
    confirmClick,
  };
  return <Ward {...props} />;
};

const EditWardPop = ({ closePop, open, confirmClick, allData, wardList }) => {
  const props = {
    title: i18n.t('SETTING_EDIT_WARD'),
    confirmText: i18n.t('SETTING_CONFIRM'),
    closePop,
    open,
    confirmClick,
    allData,
    wardList,
  };
  return <Ward {...props} />;
};

const AddRolePop = ({ closePop, open, confirmClick }) => {
  const props = {
    title: i18n.t('SETTING_ADD_ROLE'),
    confirmText: i18n.t('SETTING_ADD'),
    open,
    closePop,
    confirmClick,
  };
  return <RoleAdd {...props} />;
};

const EditRolePop = ({ closePop, open, confirmClick, allData, hospital, updatePerMissionIds }) => {
  const props = {
    title: i18n.t('SETTING_EDIT_ROLE'),
    confirmText: i18n.t('SETTING_CONFIRM'),
    closePop,
    open,
    confirmClick,
    allData,
    hospital,
    updatePerMissionIds,
  };
  return <RoleEdit {...props} />;
};

const AddUserPop = ({ closePop, open, confirmClick, itemLists }) => {
  const props = {
    title: i18n.t('SETTING_ADD_USER'),
    confirmText: i18n.t('SETTING_ADD'),
    closePop,
    open,
    confirmClick,
    itemLists,
  };
  return <User {...props} />;
};

const EditUserPop = ({ closePop, open, confirmClick, allData, itemLists }) => {
  const props = {
    title: i18n.t('SETTING_EDIT_USER'),
    confirmText: i18n.t('SETTING_CONFIRM'),
    closePop,
    open,
    confirmClick,
    allData,
    itemLists,
  };
  return <User {...props} />;
};

export { AddWardPop, EditWardPop, AddRolePop, EditRolePop, AddUserPop, EditUserPop };
